










import { Component, Prop, Vue } from 'vue-property-decorator';
import TableCard from '@/components/Table/TableCard/index.vue';
@Component({
  components: {
    TableCard,
  },
})
export default class DataTable extends Vue {
  private search: string = '';

  private headers = [
    {
      text: 'Col 1',
      align: 'center',
      value: 'colone',
    },
    {
      text: 'Col 2',
      align: 'center',
      value: 'coltwo',
    },
  ]

  private desserts = [
    {
      colone: 'Text1',
      coltwo: 'Text1',

    },
    {
      colone: 'Text2',
      coltwo: 'Text2',

    },
  ]
}
